import { render, staticRenderFns } from "./AdminAutoUpdateTask.vue?vue&type=template&id=3b6c1713&scoped=true&"
import script from "./AdminAutoUpdateTask.vue?vue&type=script&lang=js&"
export * from "./AdminAutoUpdateTask.vue?vue&type=script&lang=js&"
import style0 from "./AdminAutoUpdateTask.vue?vue&type=style&index=0&id=3b6c1713&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6c1713",
  null
  
)

export default component.exports